import { Store } from "vuex";
import { State } from "@/typings/store";
import { todosLosNombresModulos } from "./modulos";

const cerrarCanalesBD = async (store: Store<State>): Promise<void> => {
  const promesas = todosLosNombresModulos.map((nombre) =>
    store.dispatch(nombre + "/closeDBChannel")
  );
  await Promise.all(promesas);
};

export default cerrarCanalesBD;
